import { render, staticRenderFns } from "./StaffProductDetail.vue?vue&type=template&id=2c9e5cdc&scoped=true"
import script from "./StaffProductDetail.vue?vue&type=script&lang=js"
export * from "./StaffProductDetail.vue?vue&type=script&lang=js"
import style0 from "./StaffProductDetail.vue?vue&type=style&index=0&id=2c9e5cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e5cdc",
  null
  
)

export default component.exports